import {
  ADD_SERVICE,
  ADD_SERVICE_ERROR,
  ADD_SERVICE_SUCCESS,
  GET_SERVICES,
  GET_SERVICES_ERROR,
  GET_SERVICES_SUCCESS,
  GET_SERVICE,
  GET_SERVICE_ERROR,
  GET_SERVICE_SUCCESS,
  UPDATE_SERVICE,
  UPDATE_SERVICE_ERROR,
  UPDATE_SERVICE_SUCCESS,
  UPLOAD_SERVICE_ICON,
  UPLOAD_SERVICE_ICON_ERROR,
  UPLOAD_SERVICE_ICON_SUCCESS,
  TOGGLE_SERVICE_MODAL,
} from "./actionTypes";

const initialState = {
  loadingServicesError: null,
  loadingServices: false,
  loadingServicesSuccess: false,
  services: [],
  service: {},
  addServiceLoading: false,
  addServiceError: null,
  addServiceSuccess: false,
  getServiceLoading: false,
  getServiceError: null,
  getServiceSuccess: null,
  updateServiceLoading: false,
  updateServiceError: null,
  uploadingServiceIcon: false,
  uploadServiceIconSuccess: null,
  uploadServiceIconError: null,
};

const services = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVICES:
      state = {
        ...state,
        addServiceSuccess: false,
        updateServiceSuccess: false,
        loadingServices: true,
        loadingServicesError: null,
        loadingServicesSuccess: false,
        services: [],
        service: {},
      };
      break;
    case GET_SERVICES_SUCCESS:
      state = {
        ...state,
        loadingServices: false,
        loadingServicesError: null,
        loadingServicesSuccess: true,
        services: action.payload,
      };
      break;
    case GET_SERVICES_ERROR:
      state = {
        ...state,
        loadingServicesError: action.payload,
        loadingServices: false,
        loadingServicesSuccess: false,
        services: [],
        service: {},
      };
      break;
    case TOGGLE_SERVICE_MODAL:
      state = {
        ...state,
        service: {},
      };
      break;
    case ADD_SERVICE:
      state = {
        ...state,
        addServiceLoading: true,
        addServiceError: null,
        addServiceSuccess: false,
      };
      break;
    case ADD_SERVICE_SUCCESS:
      state = {
        ...state,
        addServiceLoading: false,
        addServiceError: null,
        addServiceSuccess: true,
        service: {},
      };
      break;
    case ADD_SERVICE_ERROR:
      state = {
        ...state,
        addServiceLoading: false,
        addServiceError: action.payload,
        addServiceSuccess: false,
      };
      break;
    case GET_SERVICE:
      state = {
        ...state,
        service: {},
        getServiceLoading: true,
        getServiceError: null,
        getServiceSuccess: false,
      };
      break;
    case GET_SERVICE_SUCCESS:
      state = {
        ...state,
        service: action.payload,
        getServiceLoading: false,
        getServiceSuccess: false,
        getServiceError: null,
      };
      break;
    case GET_SERVICE_ERROR:
      state = {
        ...state,
        getServiceError: action.payload,
        getServiceLoading: false,
        getServiceSuccess: false,
      };
      break;
    case UPDATE_SERVICE:
      state = {
        ...state,
        updateServiceLoading: true,
        updateServiceError: null,
        updateServiceSuccess: false,
      };
      break;
    case UPDATE_SERVICE_SUCCESS:
      state = {
        ...state,
        updateServiceLoading: false,
        updateServiceError: null,
        updateServiceSuccess: true,
        service: {},
      };
      break;
    case UPDATE_SERVICE_ERROR:
      state = {
        ...state,
        updateServiceLoading: false,
        updateServiceError: action.payload,
        updateServiceSuccess: false,
      };
      break;
    case UPLOAD_SERVICE_ICON:
      state = {
        ...state,
        uploadingServiceIcon: true,
      };
      break;
    case UPLOAD_SERVICE_ICON_SUCCESS:
      state = {
        ...state,
        uploadingServiceIcon: false,
        service: { ...state.service, icon: action.payload },
      };
      break;
    case UPLOAD_SERVICE_ICON_ERROR:
      state = {
        ...state,
        uploadingServiceIcon: false,
        uploadServiceIconError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default services;
